













import Vue from "vue";
import Component from "vue-class-component";
import Quill from "quill";
import "quill/dist/quill.snow.css";

@Component({
  props: {
    meta: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    }
  }
})
export default class WYSIWYGTypeEditor extends Vue {
  quill: null | Quill = null;
  initialContent: string = "";

  created() {
    this.initialContent = this.$props.value;
  }

  mounted() {
    const editorElement: any = this.$refs["quill-editor"];
    const quill = new Quill(editorElement, {
      modules: {
        toolbar: this.$props.meta.toolbar
      },
      theme: "snow"
    });

    this.quill = quill;
  }

  input(event: any) {
    this.$emit("input", event.target.innerHTML);
  }
}
